import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { Row } from '@app/classes/row.class';
import { Utils } from '@services/utils.service';
import { Filters } from '@app/classes/table.class';
import { environment } from 'environments/environment';
import { Service as ServiceStorage } from '@services/storage.service';
import { Service as ServiceAPI } from '@app/services/api.service';

@Injectable({ providedIn: 'root' })
export class Service {
    private token_key = 'auth_token';
    private base_url = environment.api;
    private api_type = (environment.api_type == 'php')? '.php' : '';
    private base_endpoint = (environment.api_version == 'v1')? 'user/application/' : 'user/';

    constructor(
		private Utils: Utils,
		private Router: Router,
        private ServiceStorage: ServiceStorage,
        private ServiceAPI: ServiceAPI,
	) { }
	
	async get(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'get.php' : data.item_id),  'get'); }
    async save(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'save.php' : ''), 'post'); }
    async update(data: any, item_id:any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'update.php' : 'full_update/' + item_id), 'put'); }
    async getList(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type === 'php')? 'get_list.php' : ''), 'get'); }
    async getPair(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type === 'php')? 'get_pair.php' : 'get_pair'), 'get'); }
	async getProfile(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'get_profile.php' : `get_profile/${data.item_id}`),  'get'); }
    async changeActive(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_active.php' : `active/${data.item_id}`), 'put'); }
    async changeLocked(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_locked.php' : `locked/${data.item_id}`), 'put'); }
    async changeDeleted(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'change_deleted.php' : data.item_id), 'delete'); }
	async downloadListCSV(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'download_list_csv.php' : ''),  'get'); }
	// downloadListPDF(){ return this.ServiceAPI.api_url + this.base_url + this.base_endpoint + `download_list_pdf${this.api_type}?token=' + this.ServiceAPI.token; }

	async login(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'login.php' : 'login'), 'post'); }
    async savePassword(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'save_password.php' : `save_password/${data.item_id}`), 'put'); }
    async updatePassword(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'update_password.php' : `update_password/${data.item_id}`), 'put'); }
	async forgotPassword(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'forgot_password.php' : `forgot_password/${data.access_key}`), 'post'); }
	async recoveryPassword(data: any): Promise<any> { return this.ServiceAPI.fetch(data, this.base_url + this.base_endpoint + ((environment.api_type == 'php')? 'recovery_password.php' : `recovery_password/${data.secret}`), 'put'); }
	
	async setToken(token:string) {
		this.token_key = token;
		await this.ServiceStorage.set('token', token);
	}

    async signIn(token:any, data:any) {
		// console.log(data);
		await this.ServiceStorage.set('login_status', true);
		await this.ServiceStorage.set('authenticated', true);
		await this.ServiceStorage.set('token', token);

		let uuid = await this.ServiceStorage.get('uuid');
		
		if(!uuid || uuid == 'false'){
			await this.ServiceStorage.set('uuid', this.Utils.getUUID());
		}
		
		for(var index in data){
			// console.log(index + ':' + data[index]);
			// localStorage.setItem(index, JSON.stringify(data[index]));
			await this.ServiceStorage.set(index, data[index]);
		}
	}

    async renewToken(token:any) {
		await this.ServiceStorage.set('token', token);
		await this.ServiceStorage.set('login_status', true);
		await this.ServiceStorage.set('authenticated', true);
	}

    logout() {
        this.ServiceStorage.remove(this.token_key);
        this.ServiceStorage.clear();

        this.Router.navigateByUrl('/');
    }

    async isLogged(): Promise<boolean> {
        const token = await this.ServiceStorage.get('token');
        return !!token;
    }
}

export interface FiltersUser extends Filters {
    user_id?:number;
    user_role_id?:number;
    role?:string;
    [key: string]: any;
}

export class User extends Row {
    constructor(){
        super();
    }

    public override init(){
        super.init();
        this.data = {
            user:{},
            user_data:{},
            user_address:{},
            user_settings:{},
            user_account:{},
            management:{},
            catalog_state:{},
            catalog_city:{},
            catalog_country:{},
            pager:{
                next:0,
                previous:0
            }
        };
    }
}